import BookingDetailsContent from './BookingDetailsContent';

const RentalBookingDetails = () => <BookingDetailsContent />;

export default RentalBookingDetails;
